import React from "react"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import Layout from "../components/layout"
import SubheaderFinance from "../components/subheader-finance"
import Products from "../components/products"
import Packages from "../components/packages"
import SellBlock from "../components/sell-block"
import GenericHero from "../components/generic-hero"
import InstallBlock from "../components/install-block"
import SEO from "../components/seo"
import Imgix from "react-imgix"
import { Background } from "react-imgix"
import CustomHero from "../components/custom-hero"
import PopularHero from "../components/popular-hero"
import HeroBlock from "../components/hero-block"
import SubheaderCovid from "../components/subheader-covid"

import pluginDimmer from "../images/products/plug-in-dimmer.png"
import ledLightBulb from "../images/products/led-light-bulb.png"
import doorLock from "../images/products/door-lock.png"
import thermostat from "../images/products/thermostat.png"

import lock from "../images/popular/lock.svg"
import camera from "../images/popular/camera.svg"
import gear from "../images/popular/gear.svg"

import wrench from "../images/popular/wrench.svg"
import person from "../images/popular/person.svg"
import safety from "../images/popular/safety.svg"
import video from "../images/popular/video.svg"
import control from "../images/popular/control.svg"



const PopularPage = () => {


  function openModal() {
    document.getElementById('infoModal').style.display="block";
  }


  function closeModal() {
    document.getElementById('infoModal').style.display="none";
  }



  return (
    <Layout className="popular" headerSeparator>
      <SEO title="Home Security Systems with Cameras & Smoke Detectors" />
      <SubheaderFinance
        title="Packages from "
        price="$16.99/mo"
        link="#packages"
      />

      <PopularHero
      image="/popular/popular_packages.png"
      title={"Popular Packages"}
      children={"Our Most Popular Packages"}
      body={"We've taken our best-selling products and combined them in ways that have worked well for other customers. These packages take the guesswork out of getting started and still offer you the flexibility to add any additional products you may need."}
      >
      </PopularHero>
      <div id="packages"></div>
      <div className="packages">
        <div className="package">
          <div className="package__icon">
            <img src={lock} alt="Lock" />
          </div>
          <div className="package__header t9">Safe &amp; Sound</div>
          <div className="package__price t8">$460</div>
          <a className="package__note t2" href="/monitoring/#safety">
            +
            <img src={safety} alt="Safety" />
            <span>Safety Plan</span>
          </a>
          <div className="package__finance">
            <div className="package__finance--price">
              Or $16.99/mo
            </div>
            <a className="info__finance--link" onClick={openModal}>
                <img className="modalIcon"src="/popular/info-icon.png" alt="info" />
            </a>

          </div>
          <OutboundLink
            href="https://shop.brightsuite.com/safe-sound"
            className="package__cta cta"
          >
            Buy Now
          </OutboundLink>
          <div className="package__includes">
            <div className="includes-header">includes:</div>
            <div className="includes">Touchscreen Panel</div>
            <div className="includes">Door / Window Sensor</div>
            <div className="includes">Motion Sensor</div>
            <div className="includes">Smoke Detector</div>
            <div className="includes">Water Sensor</div>
          </div>
        </div>

        <div className="package">
          <div className="package__icon">
            <img src={gear} alt="Gear" />
          </div>
          <div className="package__header t9">Easy Living</div>
          <div className="package__price t8">$645</div>
          <a className="package__note t2" href="/monitoring/#control">
            +
            <img src={control} alt="Control" />
            <span>Control Plan</span>
          </a>
          <div className="package__finance">
            <div className="package__finance--price">
              Or $30.99/mo
            </div>
            <a className="info__finance--link" onClick={openModal}>
                <img className="modalIcon"src="/popular/info-icon.png" alt="info" />
              </a>
          </div>
          <OutboundLink
            href="https://shop.brightsuite.com/easy-living-package"
            className="package__cta cta"
          >
            Buy Now
          </OutboundLink>
          <div className="package__includes">
            <div className="includes-header">includes:</div>
            <div className="includes">Touchscreen Panel</div>
            <div className="includes">Door / Window Sensor</div>
            <div className="includes">Motion Sensor</div>
            <div className="includes">Smoke Detector</div>
            <div className="includes">Water Sensor</div>
            <div className="includes includes--plus">+ Smart Door Lock</div>
            <div className="includes includes--plus">
              + Smart Plug-in Dimmer
            </div>
          </div>
        </div>

        <div className="package">
          <div className="package__icon">
            <img src={camera} alt="Camera" />
          </div>
          <div className="package__header t9">Total View</div>
          <div className="package__price t8">$910</div>
          <a className="package__note t2" href="/monitoring/#video">
            +
            <img src={video} alt="Video" />
            <span>Video Plan</span>
          </a>
          <div className="package__finance">
            <div className="package__finance--price">
              Or $44.99/mo
            </div>
            <a className="info__finance--link" onClick={openModal}>
                <img className="modalIcon"src="/popular/info-icon.png" alt="info" />
              </a>
          </div>
          <OutboundLink
            href="https://shop.brightsuite.com/total-view-package"
            className="package__cta cta"
          >
            Buy Now
          </OutboundLink>
          <div className="package__includes">
            <div className="includes-header">includes:</div>
            <div className="includes">Touchscreen Panel</div>
            <div className="includes">Door / Window Sensor</div>
            <div className="includes">Motion Sensor</div>
            <div className="includes">Smoke Detector</div>
            <div className="includes">Water Sensor</div>
            <div className="includes">Smart Door Lock</div>
            <div className="includes">Smart Plug-in Dimmer</div>
            <div className="includes includes--plus">+ WiFi Indoor Camera</div>
            <div className="includes includes--plus">+ Doorbell Camera</div>
          </div>
        </div>
      </div>

      <div className="categories">
        <div className="category">
          <div className="image">
            <Imgix
              src="/popular/safe_sound.png"
              height={500}
              width={625}
            />
          </div>
          <div className="info">
            <div className="info__header t11">Safe and Sound</div>
            <div className="info__note t11">
              <div className="info__price">
                $460<span>+</span>
              </div>
              <a className="info__type" href="/monitoring/#safety">
                <img src={safety} alt="Safety" />
                Safety Plan
              </a>
            </div>
            <div className="info__finance">
              <div className="info__finance--price">
                Or pay as little as $16.99/mo
              </div>
              <a className="info__finance--link" onClick={openModal}>
                <img className="info-icon" src="/popular/info-icon.png" alt="info" />
              </a>
            </div>
            <div className="info__desc t5 t5--loose">
              Secure your entry points plus 24/7 monitoring for security, fire and flood.
            </div>
            <div className="info__subnote t2">
              <img src={wrench} alt="Easy Self-Setup" />
              Easy Self-Setup
            </div>
            <OutboundLink
              href="https://shop.brightsuite.com/safe-sound"
              className="info__cta cta"
            >
              Shop Now
            </OutboundLink>
            {/* <div className="info__call">
              or call <span>833.374.8637</span> to customize
            </div> */}
          </div>
        </div>
        <div className="category">
          <div className="image">
            <Imgix
              src="/popular/easy-living.png"
              height={500}
              width={625}
            />
          </div>
          <div className="info">
            <div className="info__header t11">Easy Living</div>
            <div className="info__note t11">
              <div className="info__price">
                $645<span>+</span>
              </div>
              <a className="info__type" href="/monitoring/#control">
                <img alt="Control" src={control}/>
                Control Plan
              </a>
            </div>
            <div className="info__finance">
              <div className="info__finance--price">
                Or pay as little as $30.99/mo
              </div>
              <a className="info__finance--link" onClick={openModal}>
                <img className="info-icon" src="/popular/info-icon.png" alt="info" />
              </a>

            </div>
            <div className="info__desc t5 t5--loose">
            Security plus automating lights, locks and thermostats, making it easier to come and go. 
            </div>
            <div className="info__subnote t2">
              <img src={person} alt="Pro" />
              Professional Installation
            </div>
            <OutboundLink
              href="https://shop.brightsuite.com/easy-living-package"
              className="info__cta cta"
            >
              Shop Now
            </OutboundLink>
            {/* <div className="info__call">
              or call <span>833.374.8637</span> to customize
            </div> */}
          </div>
        </div>
        <div className="category">
          <div className="image">
            <Imgix
              src="/popular/total_view.png"
              height={500}
              width={625}
            />
          </div>
          <div className="info">
            <div className="info__header t11">Total View</div>
            <div className="info__note t11">
              <div className="info__price">
                $910<span>+</span>
              </div>
              <a className="info__type" href="/monitoring/#video">
                <img src={video} alt="Video" />
                Video Plan
              </a>
            </div>
            <div className="info__finance">
              <div className="info__finance--price">
                Or pay as little as $44.99/mo
              </div>
              <a className="info__finance--link" onClick={openModal}>
                <img className="info-icon" src="/popular/info-icon.png" alt="info" />
              </a>
            </div>
            <div className="info__desc t5 t5--loose">
            Home security and automation with additional visibility from indoor and outdoor cameras that allow you to see and communicate with visitors. 
            </div>
            <div className="info__subnote t2">
              <img src={person} alt="Pro" />
              Professional Installation
            </div>
            <OutboundLink
              href="https://shop.brightsuite.com/total-view-package"
              className="info__cta cta"
            >
              Shop Now
            </OutboundLink>
            {/* <div className="info__call">
              or call <span>833.374.8637</span> to customize
            </div> */}
          </div>
        </div>
      </div>

      <Packages omit="popular" />
      <InstallBlock />

    <div id="infoModal">
      <div className="modal">
          <div class="modal__close">
            <span onClick={closeModal}>&times;</span>
          </div>
          <div className="modal__top">
              <h1>Shop now. Enjoy now. Pay later.</h1>
              <p>BrightSuite is all about giving you choices, and that includes payment. You can choose to pay for your initial hardware upfront or break up the purchase into low monthly payments. Your cart Subtotal needs to be <span>at least $325.00 after any discounts have been applied</span>. Best part, with our Leasing Program, we will repair or replace any equipment as long as you are a part of the program.</p>
          </div>
          <div className="modal__divider">
            <hr></hr>
            <p>HOW IT WORKS</p>
            <hr></hr>
          </div>
          <div className="modal__bottom">
            <div className="modal__bottom--item">
              <img src="/popular/add-to-cart.svg"></img>
              <h2>Add to cart</h2>
              <p>You’ll be presented with our Leasing Program option during checkout. Select “Qualify Now” to get started.</p>
            </div>
            <div className="modal__bottom--item">
              <img src="/popular/quickly-apply.svg"></img>
              <h2>Quickly Apply</h2>
              <p>Provide us with the information to run a soft credit check to see if you qualify for leasing. Don’t worry, this won’t affect your credit score.</p>
            </div>
            <div className="modal__bottom--item">
              <img src="/popular/check-out.svg"></img>
              <h2>Check out</h2>
              <p>Your hardware fee will be broken into convenient monthly payments along with your monitoring plan.</p>
            </div>
          </div>
      </div>
      <script>


      </script>
    </div>
    </Layout>
  )
}

export default PopularPage
